<div class="row">
  <div class="col">

    <!-- Job titles filter -->
    <div class="row">
      <div class="col">
        <p class="sub-heading m-0">Job Title <span class="text-danger">*</span></p>

        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-1" #jobtitlesInputEl class="wc-form-control no-shadow w-100 inputheight mb-2"
            [formControl]="jobTitleInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'jobtitle')"
            (keyup.enter)="selectedItem($event.target.value,'jobtitle', 'enter');$event.target.blur();"
            placeholder="Enter Job Title" [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
            (blur)="removeTypeahead('jobtitle')">
          <div *ngIf="showJobTitleLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
          <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{jt.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>

        <mat-chip-grid #jobtitle_chipList>
          <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
            [removable]="removable" [ngClass]="{ 'bg-ai-chip': jobtitle.isSuggestion }"
            *ngFor="let jobtitle of jobTitleSelectedList">

            <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center"
              [ngClass]="{ 'text-webbtree-green': !jobtitle.isSuggestion }">
              <span class="mx-1">{{jobtitle.chipkey | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
            <i class="far fa-times f-12 font-weight-lighter" style="margin-left: 1px; margin-top: 5px;"
              (click)="removeChip(jobtitle, 'jobtitle')"></i>
            </span>

          </mat-chip-row>
        </mat-chip-grid>

        <div style="overflow: hidden;" [ngClass]="isOpenAITitleLoading ? 'pt-3' : ''" *ngIf="jobTitleSelectedList?.length > 0">
          <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
            *ngIf="showOpenAITitleSuggestions && !isOpenAITitleLoading">
            <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
              <i class="fa fa-stars"></i>
              Autopilot<sup class="landing"><span>AI</span></sup> Search Suggestions
            </span>
            <i class="fal fa-info-circle ml-1 pointer"
              matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
              [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
          </div>
          <div *ngIf="isOpenAITitleLoading" class="shimmer-loader"
            style="height: 23px; width: 300px; border-radius: 10px;">
          </div>
          <div class="overflow-hidden pl-2 w-100">
            <openai-suggested-titles [onlyExisiting]="true" showOnly="titles" [showIcons]="false" [showCount]="false"
              [keepSelected]="true" (change)="setTitleSuggestions($event)" [query]="openAIAll"
              (loading)="openaiTitleLoading($event)" [maxChips]="5" [updateChips]="updatedAiTitleChips"
              [clear]="clearAiTitleChips" [keepSuggestions]="true" [titleAggregateType]="jobTitleAggregateType"
              [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
            </openai-suggested-titles>





          </div>
        </div>

      </div>
    </div>

    <!-- Location filter with continent filter -->
    <!-- <div class="row mt-3">
      <div class="col-md-9">
        <p class="sub-heading m-0">Location <span class="text-danger">*</span></p>
        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-2" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="locationInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'location')"
            placeholder="Enter Location" [matAutocomplete]="location_auto" [matChipInputFor]="location_chipList"
            (blur)="onLocationInputBlur()">
          <div *ngIf="showLocationLoader" class=" spinner-border position-absolute text-black" style="top:13px; right: 7px;"
            role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
          <mat-option *ngFor="let cl of locationList"
            [value]="{key: cl.value, doc_count: cl.doc_count, continent: cl?.location_continent, location_type: cl?.location_type}"
            [matTooltip]="getTooltipText(cl)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above"
            [disabled]="isLocationDisabled(cl)">
            <span class="text-truncate">{{cl.value | titlecase}}</span>
            <span class="float-right f-12 text-9696 mt-2">{{cl?.location_type}}</span>
          </mat-option>
        </mat-autocomplete>

        <mat-chip-list #location_chipList>
            <mat-chip class="mr-2 my-1 rightsideclose text-truncate green-chip" [selectable]="selectable"
              [removable]="removable" (removed)="removeChip(cl, 'location')" *ngFor="let cl of locationSelectedList">
              <span
                class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                <span class="mx-1">{{cl.chipkey | titlecase}}</span>
              </span>
              <i class="far fa-times f-12 green-chip" matChipRemove style="margin-left: 1px;
                    margin-top: 5px;"></i>
            </mat-chip>
          </mat-chip-list>
      </div>

      <div class="col-md-3">
        <p class="sub-heading m-0">Distance<i class="fa-regular fa-circle-info f-12 ml-1"
            matTooltip="Distance filter is effective only for city-level locations"
            [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        <div class="d-flex mt-1">

          <input data-testid="auto-app-jd-filter-input-3" class="wc-form-control no-shadow inputheight mb-2 mr-2 w-100" type="number" onwheel="this.blur()"
            min="0" required [(ngModel)]="locationDistanceRange" (keyup)="wholeNumberValidation($event)" placeholder=""
            [disabled]="!hasCityLocationSelected">
          <span class="toggle ml-auto mr-5" style="flex-shrink: 0;">
            <div class="up">
              <select data-testid="auto-app-jd-filter-select-1" name="" [(ngModel)]="locationDistanceUnit" class="locationUnit no-shadow wc-select f-12"
                [disabled]="!hasCityLocationSelected">
                <option value="kilometers" selected>Kms</option>
                <option value="miles">Miles</option>
              </select>
            </div>
          </span>

        </div>
        <p *ngIf="!wholeNumberForDistance" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
          Only whole numbers are allowed</p>
        <p *ngIf="locationDistanceRange < '0'" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
          Value should be greater than 0</p>
        <p *ngIf="locationDistanceRange > '500'" class="text-danger f-12 ml-2" style="margin-bottom: 5px;">
          Value should be less than 500</p>

      </div>
    </div> -->

    <!-- Skills filter -->
    <div class="row mt-3">
      <div class="col">
        <p class="sub-heading m-0">Skills<span class="text-danger">*</span></p>

        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-4" #skillsInputEl class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="Enter Skills"
            [formControl]="skillsInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'skills')" [matAutocomplete]="skills_auto"
            (keyup.enter)="selectedItem($event.target.value,'skills', 'enter');$event.target.blur();"
            [matChipInputFor]="skills_chipList" [matChipInputAddOnBlur]="addOnBlur" (blur)="removeTypeahead('skills')">
          <div *ngIf="showSkillLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skills')">
            <mat-option *ngFor="let s of skillsList" [value]="{key: s.value, doc_count: s.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{s.value | titlecase}}</span>
              </span>
            </mat-option>
          </mat-autocomplete>

          <mat-chip-grid #skills_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
              [removable]="removable" [ngClass]="{ 'bg-ai-chip': s.isSuggestion }" *ngFor="let s of skillsSelectedList">
              <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center"
                [ngClass]="{ 'text-webbtree-green': !s.isSuggestion }">
                <span class="mx-1">{{s.chipkey | titlecase}}</span>
                <span matChipRemove  class="mr-1">
                  <i class="far fa-times f-12" style="margin-left: 1px; margin-top: 5px;"
                  (click)="removeChip(s, 'skills')"></i>
                </span>
              </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div style="overflow: hidden;" [ngClass]="isOpenAISkillsLoading || showOpenAISkillsSuggestions ? 'pt-3' : ''" *ngIf="skillsSelectedList?.length > 0">
            <div class="pr-2 flex-shrink-0 d-flex align-items-center mb-2"
              *ngIf="showOpenAISkillsSuggestions && !isOpenAISkillsLoading">
              <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                <i class="fa fa-stars"></i>
                Autopilot<sup class="landing"><span>AI</span></sup> Search Suggestions
              </span>
              <i class="fal fa-info-circle ml-1 pointer"
                matTooltip="Get AI recommended job titles and skills to expand your search and get enhanced results."
                [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above"></i>
            </div>
            <div *ngIf="isOpenAISkillsLoading" class="shimmer-loader"
              style="height: 23px; width: 300px; border-radius: 10px;"></div>
            <div class="overflow-hidden pl-2 w-100">
              <openai-suggested-titles [onlyExisiting]="true" showOnly="skills" [showIcons]="false" [showCount]="false"
                (change)="setSkillsSuggestions($event)" (loading)="openaiSkillsLoading($event)" [query]="openAIAll"
                [maxChips]="5" [clear]="clearAiSkillChips" [updateChips]="updatedAiSkillChips" [keepSuggestions]="true"
                [jobtitleAndSkillAIData]="jobtitleAndSkillAIData">
              </openai-suggested-titles>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Function filter -->


    <!-- Seniority and Experience filter -->
    <div class="row mt-3">
      <div class="col-md-6">
       <p class="sub-heading m-0">Function</p>
        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-5" class="wc-form-control no-shadow w-100 inputheight mb-2" [formControl]="functionsInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'functions')"
            placeholder="Enter Function Name" [matAutocomplete]="functions_auto" [matChipInputFor]="functions_chipList"
            (blur)="removeTypeahead('functions')">
          <div *ngIf="showFunctionsLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <mat-autocomplete #functions_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'functions')">
          <mat-option *ngFor="let fL of functionsList" [value]="{key: fL.value, doc_count: fL.doc_count}">
            <span class="d-flex align-items-center">
              <span class="text-truncate">{{fL.value | titlecase}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
        <mat-chip-grid #functions_chipList>
          <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
            [removable]="removable" *ngFor="let fun of functionsSelectedList">

            <span class="trim-chip text-truncate green-chip hoverable-element f-12 d-flex align-items-center">
              <span class="mx-1">{{fun.chipkey | titlecase}}</span>
            </span>
            <span matChipRemove  class="mr-1">
               <i class="far fa-times f-12 green-chip" style="margin-left: 1px;
                    margin-top: 5px;" (click)="removeChip(fun, 'functions')"></i>
            </span>
          </mat-chip-row>
        </mat-chip-grid>

      </div>

      <!-- Experience filter -->
      <div class="col-md-6">
        <div class="row">
          <div class="col">
            <p class="sub-heading m-0">Minimum Experience</p>
            <input data-testid="auto-app-jd-filter-input-6" class="wc-form-control no-shadow inputheight" type="number" [formControl]="yearsofexperienceFrom"
              placeholder="eg. 1, 2" (keyup)="typeAheadSearch($event, 'fromyearsofexperience')" onwheel="this.blur()">
          </div>
          <div class="col">
            <p class="sub-heading m-0">Maximum Experience</p>
            <input data-testid="auto-app-jd-filter-input-7" class="wc-form-control no-shadow inputheight" type="number" [formControl]="yearsofexperienceTo"
              placeholder="eg. 1, 2" (keyup)="typeAheadSearch($event, 'toyearsofexperience')" onwheel="this.blur()">
          </div>
        </div>

        <p style="margin-left: 45px;"
          *ngIf="(yearsofexperienceTo.value == 0) || (yearsofexperienceTo.value != null && yearsofexperienceFrom.value != null) && (yearsofexperienceFrom.value > yearsofexperienceTo.value) && !(yearsofexperienceFrom.value < 0 || yearsofexperienceFrom.value > 40 || yearsofexperienceTo.value < 0)"
          class="f-12 text-danger"> Invalid Input </p>
        <p style="margin-left: 45px;"
          *ngIf="yearsofexperienceFrom.value < 0 || yearsofexperienceFrom.value > 40 || yearsofexperienceTo.value > 40 || yearsofexperienceTo.value < 0"
          class="f-12 text-danger"> Enter a valid number in the range (0 – 40)</p>

      </div>
    </div>

    <!-- Job Target Industry filter -->
    <div class="row mt-3">
      <div class="col">
        <p class="sub-heading m-0">Target Industry</p>
        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-8" class="wc-form-control no-shadow w-100 inputheight mb-2"
            placeholder="eg. Information Technology, Banking, etc" [formControl]="industryInput"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (keyup)="onTypeAheadSearch($event, 'industry')"
            [matAutocomplete]="industry_auto" [matChipInputFor]="industry_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('industry')">
          <div *ngIf="showIndustryLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <mat-autocomplete #industry_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'industry')">
            <mat-option *ngFor="let industry of industryList"
              [value]="{key: industry.value, doc_count: industry.doc_count}">
              <span class="d-flex align-items-center">
                <span class="text-truncate">{{industry.value | titlecase}}</span>
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-chip-grid #industry_chipList>
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip f-12"
              [removable]="removable" *ngFor="let industry of industrySelectedList">


              <span class="trim-chip text-truncate text-webbtree-green">{{industry.chipkey | titlecase}}
              </span>


              <span matChipRemove  class="mr-1">
                <i class="far fa-times f-12 green-chip" style="margin-left: 1px; margin-top: 5px;"
                (click)="removeChip(industry, 'industry')"></i>
            </span>
            </mat-chip-row>
          </mat-chip-grid>
          <div class="d-flex flex-column">
            <span class="trim-chip  text-webbtree-green underline-on-hover d-flex" *ngFor="let jt of industryTopList"
              (click)="addToSelectedList(jt,'industry')">
              <span class="text-truncate">{{jt.key | titlecase}}</span>
              <span class="f-12 text-webbtree-green">({{jt.doc_count}})</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Job Target Company filter -->
    <div class="row mt-3">
      <div class="col">
        <p class="sub-heading m-0">Target Company</p>
        <div class="position-relative">
          <input data-testid="auto-app-jd-filter-input-9" class="wc-form-control no-shadow w-100 inputheight mb-2" placeholder="eg. Amazon, Google, etc"
            [formControl]="companyInput" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (keyup)="onTypeAheadSearch($event, 'company')" [matAutocomplete]="company_auto"
            [matChipInputFor]="company_chipList" [matChipInputAddOnBlur]="addOnBlur"
            (blur)="removeTypeahead('company')">
          <div *ngIf="showCompanyLoader" class=" spinner-border position-absolute text-black"
            style="top:13px; right: 7px;" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'company')">
            <mat-option *ngFor="let comp of companyList" [value]="{key: comp.key, doc_count: comp.doc_count}">
              <span class="d-flex align-items-center">
                <span>
                  <span class="compnaylogoplaceholder mr-2">
                    <img [src]="comp?.companylogo" *ngIf="comp?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!comp?.companylogo"></i>
                  </span>
                </span>
                <span class="text-truncate">{{comp.key | titlecase}}</span>
              </span>
            </mat-option>
          </mat-autocomplete>

          <mat-chip-grid #company_chipList class="company-mat-chip">
            <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
              [ngClass]="{ 'bg-ai-chip': company.isSuggested, 'bg-chip': !company.isSuggested, 'excluded-chip': company.isExcluded }"
              [removable]="removable" *ngFor="let company of companySelectedList">
              <span class="compnaylogoplaceholder-chip">
                <img [src]="company?.companylogo" *ngIf="company?.companylogo" class="img-fluid" alt="">
                <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
              </span>
              <span
                class="trim-chip text-truncate text-webbtree-green hoverable-element f-12 d-flex align-items-center">
                <span class="mx-1">{{company.chipkey | titlecase}}</span>
              </span>

              <span
                class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center font-weight-lighter">
                <mat-icon *ngIf="company.isExcluded" class="f-12 mr--5 mt-1 text-danger" matTooltip="Excluded"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }"><i class="fas fa-minus-circle pointer"
                    (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
                <mat-icon *ngIf="!company.isExcluded" matTooltip="Exclude"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" class="f-12 mr--5 mt-1"><i
                    class="far fa-minus-circle pointer"
                    (click)="excludeFilterItem(company.key,'company')"></i></mat-icon>
              </span>
            <span matChipRemove  class="mr-1">
              <i class="far fa-times f-12 green-chip m-0" (click)="removeChip(company, 'company')"></i>
            </span>
            </mat-chip-row>
          </mat-chip-grid>

          <div class="d-flex flex-column mt-2">
            <!-- ai suggestions -->
            <div>
              <div class="pr-2 flex-shrink-0 d-flex align-items-center"
                *ngIf="loadSuggestions && companyAiSuggestions.length">
                <span style="line-height: 1.9;" class="ai-text-gradient font-weight-500 ml-1">
                  <i class="fa fa-stars"></i>
                  Similar Companies
                </span>
              </div>
              <div *ngIf="!loadSuggestions && companySelectedList.length" class="shimmer-loader"
                style="height: 23px; width: 300px; border-radius: 10px;"></div>

              <div class="d-flex overflow-hidden pl-2 w-100 flex-wrap">
                <div class="d-flex align-items-center mb-2 pointer ai_chip" *ngFor="let c of companyAiSuggestions"
                  (click)="addToSelectedList(c,'company')">
                  <mat-icon class="leading_icon">add</mat-icon>
                  <span class="compnaylogoplaceholder-chip mr-1"
                    [ngClass]="{'bg-white': c?.companylogo , 'bg-color-company': !c?.companylogo}">
                    <img [src]="c?.companylogo" *ngIf="c?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!c?.companylogo"></i>
                  </span>
                  <span class="text-truncate">{{c.chipkey | titlecase}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-right limited-wrapper">
        <div class="limited-results-tooltip" id="limited-results" *ngIf="showLimitedResultsInfo">
          <div class="tooltip-header">
            <div class="header-left">
              <i class="fa-regular fa-circle-info f-12" style="color: #004C89"></i>
              <span class="tooltip-title">Limited results</span>
            </div>

            <span class="pointer f-12" (click)="showLimitedResultsInfo = false"><i class="fa-solid fa-xmark"></i></span>
          </div>

          <p class="tooltip-text">
            Consider expanding titles, experience, or location.
          </p>
        </div>
        <div>
          <div class="missing-field-msg mr-4" *ngIf="getMissedMandatoryFiels().length > 0">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>Missing required field: {{getMissedMandatoryFiels().join(', ')}}</span>
          </div>

          <div class="missing-field-msg mr-4" *ngIf="changedJD">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>You have unsaved job description changes. Click <b>Submit</b> to update the JD.</span>
          </div>

          <button data-testid="auto-app-jd-filter-button-1" class="btn-trms-medium mt-6" (click)="openCannotModifyModel()"
            [disabled]="showModifyProjectSpinner || changedJD || filterInputError() || showLimitedResultsInfo"
            [ngClass]="{ 'bg-gray': changedJD || filterInputError(),  'text-center': showSubmitJdSpinner }">
            <span [ngClass]="{'spinner-border text-white spinner-size': showModifyProjectSpinner }"
              [ngStyle]="{ 'width: 20px; height: 20px;': showModifyProjectSpinner }">
              {{showModifyProjectSpinner ? '' : 'Save & Proceed'}}
            </span>
          </button>
        </div>


      </div>
    </div>



  </div>
</div>

<!-- For Cannot Modify JD model -->
<ng-template #cannotModifyModel class="modal">
  <div class="modal-content p-3">
    <!-- <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-400">The Job Description and Autopilot<sup
          style="top:-1px!important;"><span>AI</span></sup> Search Criteria cannot be modified once the project
        is
        created.</span>
    </div> -->
    <div class="d-flex flex-column w-100 mt-2">
      <span class="f-14 font-weight-400 mt-1">Do you want to continue?</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-jd-filter-button-2" class="btn-trms-white mr-3" (click)="dismiss()">Cancel</button>

        <button data-testid="auto-app-jd-filter-button-3" class="btn-trms-medium mt-6" (click)="createProject()"
          [disabled]="showCreateProjectSpinner || filterInputError()"
          [ngClass]="{ 'bg-gray': filterInputError(),  'text-center': showSubmitJdSpinner }">
          <span [ngClass]="{'spinner-border text-white spinner-size': showCreateProjectSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showCreateProjectSpinner }">
            {{showCreateProjectSpinner ? '' : 'Continue'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For Candidate Not fount model -->
<ng-template #candidateNotFoundModel class="modal">
  <div class="modal-content p-3 text-center">

    <div class="w-100" style="display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 149px; height: 96px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-600">No Matches Found</p>
        <p class="f-14 font-weight-400 mt-3">No candidates match your current JD and filters. Try adjusting your AI
          Search criteria.</p>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col text-center">
        <button data-testid="auto-app-jd-filter-button-4" class="btn-trms-medium" (click)="dismiss()">Review AI Search Criteria</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #insuffiicientCandidatesModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <p class="f-16 font-weight-600"><span class="mr-2"><i class="fa-solid fa-triangle-exclamation"
            style="color: #FFED27;"></i></span>Your search results are a bit narrow </p>
      <span class="pointer f-14" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="w-100">
      <div>
        <p class="f-14 font-weight-400">Right now, the criteria you’ve selected are returning a smaller talent pool.
          With fewer profiles available, the AI may not have enough data to deliver strong, high-quality matches.</p>

        <div class="insufficient-modal p-3 mb-4">
          <p class="f-14 font-weight-500 mb-3">
            To get better results, you can try one or more of the following:
          </p>
          <div class="d-flex mb-2">
            <span class="mr-2 font-weight-400"><i class="fa-regular fa-circle-1"></i></span>
            <span class="f-14">Adding related job titles or skills</span>
          </div>

          <div class="d-flex mb-2">
            <span class="mr-2 font-weight-400"><i class="fa-regular fa-circle-2"></i></span>
            <span class="f-14">
              Broadening location or experience range
            </span>
          </div>

          <div class="d-flex mb-3">
            <span class="mr-2 font-weight-400"><i class="fa-regular fa-circle-3"></i></span>
            <span class="f-14">
              Expanding target industries or companies
            </span>
          </div>
          <p class="f-14 font-weight-400 mb-0">
            Making one or two small adjustments can significantly improve the quality
            of AI-generated matches.
          </p>
          <hr>
          <p class="f-14 font-weight-500 mb-4">
            Note: Job details and Autopilot evaluation criteria can’t be changed after the project is created.
          </p>
        </div>

      </div>
    </div>

    <div class="row mt-2">
      <div class="col text-right">

        <button data-testid="auto-app-jd-filter-button-5" class="btn-trms-white mr-3" (click)="createProject()" *ngIf="totalEligibleCandidates > 0"
          [disabled]="showCreateProjectSpinner || filterInputError()"
          [ngClass]="{ 'bg-gray': filterInputError(),  'text-center': showSubmitJdSpinner }">
          <span [ngClass]="{'spinner-border spinner-size text-blue': showCreateProjectSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showCreateProjectSpinner }">
            {{showCreateProjectSpinner ? '' : 'Continue Anyways'}}
          </span>
        </button>
        <button data-testid="auto-app-jd-filter-button-6" class="btn-trms-medium mt-6" (click)="dismiss()">Review & Expand Search</button>


      </div>
    </div>
  </div>

</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
